<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <!-- Page Wrapper -->
    <div class="page-wrapper" ref="formContainer">
      <!-- Page Content -->
      <div class="content container-fluid">
        <!-- Page Header -->
        <shift-header
          :title="title"
          :path="path"
          :text="text"
          :text1="text1"
          :text2="text2"
          :text3="text3"
          :text4="text4"
          :search_data="searchData2"
          :columns="columns"
          :current-week-start="currentWeekStart"
          :current-week-end="currentWeekEnd"
          @add-shift="openAddShiftModel"
          @add-schedule="openAddScheduleModel"
          @add-dept-schedule="openAddDeptScheduleModel"
          @copy-week="handleCopyWeek"
        />

        <!-- /Page Header -->
        <!-- Content Starts -->
        <!-- Search Filter -->
        <shift-scheduling-filter
          :hasEditPermission="hasEditPermission"
          @search-schedule="searchSchedule"
          :sDate="sDate"
          :eDate="eDate"
        />
        <!-- Search Filter -->
        <div class="row">
          <div class="col-md-12">
            <draggable
              v-model="shifts"
              group="shift"
              class="row parentdrag"
              :disabled="!hasCreatePermission"
              :move="checkMove"
              id="parentdrag"
              :animation="200"
            >
              <div
                class="col-md-3 col-lg-2 col-sm-4 p-1"
                v-for="shift in shifts"
                :key="shift.shift_id"
              >
                <div
                  class="card mb-0"
                  :style="{
                    minHeight: '57px',
                    borderColor: assignShiftColor(shift.shift_id),
                    backgroundColor: assignShiftBGColor(shift.shift_id),
                  }"
                >
                  <div class="text-xs card-header p-1">
                    {{ shift?.shift_name }}
                  </div>
                  <div class="card-body p-1">
                    <span class="text-xs username-info m-b-10">{{
                      shift.start_time && shift.end_time
                        ? `${shift?.start_time} -
                      ${shift?.end_time}
                      (${
                        shift?.start_time && shift?.end_time
                          ? fetchTotalHours(shift?.start_time, shift?.end_time)
                          : ""
                      })`
                        : "Shift time not set"
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <a-table
                  class="stripped table-hover"
                  :columns="columns"
                  :data-source="sortedScheduleData"
                  :pagination="pagination"
                  @change="handleTableChange"
                >
                  <template #bodyCell="{ column, record }">
                    <draggable
                      :list="record[column.key]"
                      group="shift"
                      @change="
                        handleDragChange(
                          record,
                          [record.id, column.key],
                          record[column.key]
                        )
                      "
                      :disabled="!hasCreatePermission || column.key === 'Name'"
                      :move="checkMove"
                      id="childdddrag"
                      :animation="200"
                      ghost-class="drag-ghost"
                      chosen-class="drag-chosen"
                    >
                      <template v-if="column.key === 'Name'">
                        <h2 class="table-avatar">
                          <router-link
                            :to="'/profile/' + record?.id"
                            class="avatar"
                          >
                            <img
                              v-if="record?.avatar && record?.avatar != null"
                              :src="getEmployeeAvatar(record?.avatar)"
                              alt="User Image"
                              @error="handleImageError(record)"
                            />
                            <img
                              v-else
                              :src="
                                require(`@/assets/img/profiles/${defaultAvatar}`)
                              "
                              alt="User Image"
                            />
                          </router-link>
                          <router-link :to="'/profile/' + record?.id"
                            >{{ record.first_name }}
                            {{ record.last_name }}</router-link
                          >
                        </h2>
                      </template>
                      <template v-if="column.key != 'Name'">
                        <div
                          v-if="
                            record[column.key] && record[column.key]?.length
                          "
                        >
                          <div
                            class="user-add-shedule-list"
                            v-for="date_data in record[column.key]"
                            :key="'date_date_' + date_data"
                          >
                            <h2>
                              <a
                                class="childdraglink"
                                href="javascript:;"
                                data-bs-toggle="modal"
                                data-bs-target="#add_schedule"
                                :style="{
                                  border: '1px solid',
                                  borderColor: assignShiftColor(
                                    date_data.shift_id
                                  ),
                                  backgroundColor: assignShiftBGColor(
                                    date_data.shift_id
                                  ),
                                  opacity: isModalLocked ? '0.6' : '1',
                                  pointerEvents: isModalLocked
                                    ? 'none'
                                    : 'auto',
                                }"
                                :class="{ disabled: isModalLocked }"
                                @click="
                                  !isModalLocked && onEditSchedule(date_data)
                                "
                                v-if="hasEditPermission"
                              >
                                <span
                                  class="username-info m-b-10"
                                  v-if="
                                    date_data?.shift?.start_time ||
                                    date_data?.shift?.end_time
                                  "
                                >
                                  {{ date_data?.shift?.start_time }}
                                  -
                                  {{ date_data?.shift?.end_time }}
                                </span>
                                <span
                                  class="username-info m-b-10"
                                  v-else-if="
                                    date_data?.start_time || date_data?.end_time
                                  "
                                >
                                  {{ date_data?.start_time }}
                                  -
                                  {{ date_data?.end_time }}
                                </span>
                                <span class="username-info m-b-10" v-else>
                                  Please update Shift Timings
                                </span>
                              </a>
                              <a
                                v-else
                                disabled
                                style="border: 1px solid"
                                :style="{
                                  borderColor: assignShiftColor(
                                    date_data.shift_id
                                  ),
                                  backgroundColor: assignShiftBGColor(
                                    date_data.shift_id
                                  ),
                                }"
                              >
                                <span class="username-info m-b-10"
                                  >{{ date_data?.shift?.start_time }}
                                  -
                                  {{ date_data?.shift?.end_time }}</span
                                >
                              </a>
                            </h2>
                          </div>
                        </div>
                        <div class="user-add-shedule-list" v-else>
                          <a
                            href="javascript:;"
                            name="testing"
                            data-bs-toggle="modal"
                            data-bs-target="#add_schedule"
                            v-if="hasCreatePermission"
                            @click="
                              onAddSchedule(
                                record.id,
                                column.key,
                                record.emp_department_id
                              )
                            "
                          >
                            <span><i class="fa-solid fa-plus"></i></span>
                          </a>
                          <span v-else><i class="fa-solid fa-plus"></i></span>
                        </div>
                      </template>
                    </draggable>
                  </template>
                </a-table>
              </div>

              <div class="showentries mb-3">
                <label
                  >Show
                  <select v-model="pagination.pageSize" @change="updatePerPage">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  entries</label
                >
              </div>
            </draggable>
          </div>
        </div>
        <!-- /Content End -->
      </div>
      <!-- /Page Content -->
      <shift-list-model
        @delete-shift="deleteShift"
        :deleteId="deleteID"
        :editShift="editShift"
        :closeModal="closeModal"
      ></shift-list-model>
      <edit-schedule-model
        :addEmployeeId="addEmployeeId"
        :editSchedule="editSchedule"
        @add-schedule="openAddScheduleModel"
        @reload-data="reloadData"
      ></edit-schedule-model>
      <dept-schedule-model
        @add-dept-schedule="openAddDeptScheduleModel"
        @reload-data="reloadData"
      ></dept-schedule-model>
    </div>

    <div
      id="daliy_schedule_manage_colvis"
      class="modal custom-modal fade"
      role="dialog"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Manage Column Visibility</h5>
            <!-- <small>select the column from the default that you want to hide</small> -->
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="modal_team_information_close"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div
                class="col-md-6"
                v-for="(column, key) in columns_"
                :key="column.key"
              >
                <div class="input-block mb-3 d-flex">
                  <div class="form-switch" style="margin-right: 5px">
                    <input
                      v-model="column.visibility"
                      type="checkbox"
                      class="form-check-input"
                      :id="'customSwitch_' + column.key"
                      value="false"
                      :checked="column.visibility"
                    />
                  </div>
                  <label class="col-form-label"> {{ column?.title }} </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- /Page Wrapper -->
  </div>
</template>
<script>
import { ref } from "vue";
import axios from "axios";
import moment from "moment";
import { notification } from "ant-design-vue";
import { VueDraggableNext } from "vue-draggable-next";

var pagination = { total: 0, current: 1, pageSize: 10 };

const currentDate = ref(new Date());
const currentDateOne = ref(new Date());

const columns = [
  {
    title: "Scheduled Shift",
    dataIndex: "Name",
    key: "Name",
    sorter: false,
    fixed: "left",
  },
];

export default {
  emits: ["reload-data"],
  data() {
    return {
      search_data: null,
      perpage: 10,
      pagination: pagination,
      scheduleData: [],
      params: null,
      title: "Daily Scheduling",
      path: "Dashboard",
      text: "Employees",
      text1: "Shift Scheduling",
      text2: "Shifts",
      text3: "Assign Shifts",
      text4: "Assign Department Shifts",
      defaultAvatar: "avatar-01.jpg",
      isFocused: false,
      startdate: currentDate,
      startdateone: currentDateOne,
      columns_d: columns,
      columns_: columns,
      columns: null,
      deleteID: null,
      editShift: null,
      editSchedule: null,
      closeModal: false,
      dates: [],
      shifts: [],
      addEmployeeId: null,
      addDeptId: null,
      searchData: null,
      searchData2: null,
      sDate: null,
      eDate: null,
      hasReadPermission: null,
      hasCreatePermission: null,
      hasEditPermission: null,
      hasDeletePermission: null,
      shiftColors: [
        "#FF0000", // red
        "#0000FF", // blue
        "#FF00FF", // magneta
        "#808000", // yellow green
        "#8B4513", // brown
        "#F82F72", // pink
        "#A245F7", // purple
        "#00BFFF", // deep sky blue
        "#D0CB05", // yellow type
        "#4BA8ED", // sky
        "#1EB53A", // green
        "#FF8000", // orange
        "#404040", // grey
        "#7B68EE", // medium slate blue
        "#008B8B", // dark cyan
      ],
      startDayOfWeek: "Monday",
      currentWeekStart: "",
      currentWeekEnd: "",
      isDataLoading: false,
    };
  },
  components: {
    draggable: VueDraggableNext,
  },
  methods: {
    calculateWeekDates() {
      let startDate = moment();
      while (startDate.format("dddd") !== this.startDayOfWeek) {
        startDate.subtract(1, "day");
      }

      const endDate = moment(startDate).add(6, "days");

      return {
        currentWeekStart: startDate.format("YYYY-MM-DD"),
        currentWeekEnd: endDate.format("YYYY-MM-DD"),
      };
    },
    handleCopyWeek(targetWeek) {
      const data = {
        current_week_start: this.currentWeekStart,
        current_week_end: this.currentWeekEnd,
        target_week_start: targetWeek.startDate,
        target_week_end: targetWeek.endDate,
      };

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .post("schedule/copy-schedules", data)
        .then((response) => {
          this.reloadData();
          loader.hide();

          notification.open({
            message: response.data.message || "Week copied successfully",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });
        })
        .catch((error) => {
          this.reloadData();
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message || "Failed to copy week",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    setCurrentWeekDates() {
      const { currentWeekStart, currentWeekEnd } = this.calculateWeekDates();
      this.currentWeekStart = currentWeekStart;
      this.currentWeekEnd = currentWeekEnd;
    },
    checkMove: function (evt) {
      console.log(evt.to.id);
      console.log("-----from----");
      console.log(evt.from.id);
      //console.log(evt.draggedContext.element);

      if (evt.to.id == "parentdrag" && evt.from.id == "childdddrag") {
        return false;
      }

      if (evt.draggedContext.element) {
        return true;
      } else {
        return false;
      }
      //console.log(evt.draggedContext.element.schedule_id);
      //return (evt.draggedContext.element.name!=='apple');
    },
    assignShiftColor(index) {
      return this.shiftColors[index % this.shiftColors.length];
    },
    assignShiftBGColor(index) {
      var bgcolor = this.shiftColors[index % this.shiftColors.length];
      return bgcolor + "2a";
    },
    async handleDragChange(record, key, date_data) {
      if (record[key[1]].length) {
        var token = window.localStorage.getItem("token");
        axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        const data = {
          record: record,
          key: key,
          date_data: date_data,
        };

        let loader = this.$loading.show({
          container: this.$refs.formContainer,
          canCancel: false,
        });

        try {
          const response = await axios.post(
            "/schedule/dragged-schedule-data",
            data
          );
          this.isDataLoading = true;
          await this.reloadData(false);
          loader.hide();

          notification.open({
            message: response.data.message || "Schedule updated Successfully",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });
        } catch (error) {
          loader.hide();
          await this.reloadData(false);

          var response = error.response;

          if (
            response &&
            response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: { background: process.env.VUE_APP_WARNING_COLOR },
            });

            this.$router.push({ name: "login" }).catch(() => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: { background: process.env.VUE_APP_WARNING_COLOR },
            });
          }
        }
      }
    },
    async reloadData(showLoader = true) {
      // this.isDataLoading = true;
      await this.fetchWeekDay(showLoader);
      // this.fetchScheduleData(this.searchData);
      // this.getAllShiftList();
      // this.isDataLoading = false;
    },
    onAddSchedule(id, date, department_id) {
      this.addEmployeeId = null;
      this.$nextTick(() => {
        this.addEmployeeId = {
          id: id,
          date: date,
          department_id: department_id,
        };
      });
    },
    handleTableChange(pagesize) {
      const mergeObj = { ...pagesize, ...this.searchData };

      this.fetchScheduleData(mergeObj);
    },
    updatePerPage() {
      var params = { per_page: this.pagination.pageSize, ...this.searchData };
      this.fetchScheduleData(params);
    },
    handleImageError(record) {
      record.avatar = null;
      record.avatar = `assets/img/profiles/${this.defaultAvatar}`;
    },
    getEmployeeAvatar(avatar) {
      return `${process.env.VUE_APP_IMAGE_BASE_URL}${avatar}`;
    },
    addFocusClass() {
      this.isFocused = true;
    },
    removeFocusClass() {
      this.isFocused = false;
    },
    onDeleteShift(id) {
      this.deleteID = id;
    },
    onEditSchedule(record) {
      this.editSchedule = null;
      this.$nextTick(() => {
        this.editSchedule = record;
      });
    },
    openAddShiftModel() {
      this.editShift = null;
    },
    openAddScheduleModel() {
      this.addEmployeeId = null;
      this.editSchedule = null;
    },
    openAddDeptScheduleModel() {
      this.addDeptId = null;
      this.editSchedule = null;
    },
    searchSchedule(params) {
      this.searchData = params;
      this.fetchScheduleData(this.searchData);
    },
    setColumnData(startDate, endDate) {
      const start_date = moment(startDate);
      const end_date = moment(endDate);
      const dateColumn = [];

      this.sDate = start_date;
      this.eDate = end_date;

      while (start_date.isSameOrBefore(end_date)) {
        dateColumn.push([
          start_date.format("YYYY-MM-DD"),
          start_date.format("ddd D"),
        ]);
        this.dates.push(start_date.format("YYYY-MM-DD"));
        start_date.add(1, "day");
      }

      var datesColumn = [];

      dateColumn.forEach((element) => {
        datesColumn.push({
          title: element[1],
          dataIndex: element[1],
          key: element[0],
        });
      });

      this.columns = [...this.columns_d, ...datesColumn];

      this.columns_ = [...this.columns_d, ...datesColumn].map((column) => ({
        ...column,
        visibility: column.visibility !== undefined ? column.visibility : true, // default to true
      }));
    },
    async fetchScheduleData(pagesize = null, showLoader = true) {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      // const start_date = moment().format("YYYY-MM-DD");
      // const end_date = moment().add(5, "days").format("YYYY-MM-DD");

      let start_date = moment();
      // Week based on startDayOfWeek
      while (start_date.format("dddd") !== this.startDayOfWeek) {
        start_date.subtract(1, "day");
      }
      start_date = start_date.format("YYYY-MM-DD");
      const end_date = moment(start_date).add(6, "days").format("YYYY-MM-DD");

      var params = {
        params: {
          per_page: this.pagination.pageSize,
          start_date: start_date,
          end_date: end_date,
        },
      };

      if (
        pagesize &&
        pagesize != null &&
        pagesize?.pageSize != null &&
        pagesize?.current != null
      ) {
        params.params.per_page = pagesize.pageSize;
        params.params.page = pagesize.current;
      }

      if (pagesize && pagesize?.employee_id != null) {
        params.params.employee_id = pagesize.employee_id;
      }

      if (pagesize && pagesize?.department_id != null) {
        params.params.department_id = pagesize.department_id;
      }

      if (pagesize && pagesize?.start_date != null) {
        params.params.start_date = pagesize.start_date;
      }

      if (pagesize && pagesize?.end_date != null) {
        params.params.end_date = pagesize.end_date;
      }

      this.setColumnData(params?.params?.start_date, params?.params?.end_date);

      this.isDataLoading = true;
      let loader = null;
      if (showLoader) {
        loader = this.$loading.show({
          container: this.$refs.formContainer,
          canCancel: false,
        });
      }

      this.searchData2 = params.params;

      await axios
        .get("schedule/list", params)
        .then((response) => {
          if (response.status == 200) {
            this.pagination.total = response?.data?.data?.total;
            this.pagination.current = response?.data?.data?.current_page;
            this.pagination.pageSize = response?.data?.data?.per_page;

            if (response?.data?.data?.data) {
              this.scheduleData = response?.data?.data?.data;
            } else {
              this.scheduleData = [];
            }
          }

          if (loader) loader.hide();
          this.isDataLoading = false;
        })
        .catch((error) => {
          if (loader) loader.hide();
          console.log("wages error");
          console.log(error);
          var response = error.response;

          this.scheduleData = [];

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    async deleteShift(id) {
      if (id != null) {
        var token = window.localStorage.getItem("token");
        axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        await axios
          .delete("/shifts/" + id, [])
          .then((response) => {
            notification.open({
              message: response?.data?.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_SUCCESS_COLOR,
              },
            });
            this.closeModal = true;
            this.deleteID = null;
          })
          .catch((error) => {
            this.closeModal = true;
            this.deleteID = null;
            if (error.response) {
              var response = error.response;

              notification.open({
                message: response?.data?.message,
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_WARNING_COLOR,
                },
              });
            } else {
              notification.open({
                message: "Server Error",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_WARNING_COLOR,
                },
              });
            }
          });
      }
    },
    getScheduleDataDateUserWise(date, record) {
      record.date_data = [];
      if (date && record && record?.schedule_data?.length) {
        record.schedule_data.forEach((schedule) => {
          if (schedule.date == date) {
            record.date_data.push(schedule);
          }
        });
      }
      return record.date_data;
    },

    fetchTotalHours(startTime, endTime) {
      if (startTime && endTime) {
        // const startDate = new Date(2000-01-01 ${startTime});
        // const endDate = new Date(2000-01-01 ${endTime});

        // Parse the start and end times
        const startDate = new Date(`2000-01-01T${startTime}Z`);
        const endDate = new Date(`2000-01-01T${endTime}Z`);

        // endTime is earlier than startTime (overnight shift)
        if (endDate < startDate) {
          endDate.setDate(endDate.getDate() + 1);
        }

        // Calculate the time difference in milliseconds
        const timeDifference = endDate - startDate;

        // Calculate hours and minutes
        const totalHours = Math.floor(timeDifference / (1000 * 60 * 60));
        const totalMinutes = Math.floor(
          (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
        );

        // Format the result
        const formattedResult = `${totalHours} hrs ${totalMinutes} min`;

        return formattedResult;
      }
    },

    convertUTCToLocal(time) {
      if (time) {
        const [hours, minutes, seconds] = time.split(":").map(Number);
        // Determine AM or PM
        const period = hours >= 12 ? "PM" : "AM";

        let m = minutes;

        // Convert hours to 12-hour format
        let hours12 = hours % 12;
        hours12 = hours12 === 0 ? 12 : hours12; // 0 should be treated as 12 in 12-hour format
        if (m < 10) {
          m = "0" + m;
        }

        if (hours12 < 10) {
          hours12 = "0" + hours12;
        }

        // Construct the formatted time string
        const formattedTime = `${hours12}:${m}`;

        // Return the formatted time with period
        return `${formattedTime} ${period}`;
      }
      return null;
    },
    async getAllShiftList() {
      try {
        var token = window.localStorage.getItem("token");
        axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        const response = await axios.get("shifts/all");

        this.shifts = response?.data?.data || null;
        // console.log(this.shifts);
      } catch (error) {
        return error.response.data;
      }
    },
    async fetchWeekDay(showLoader = true) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("/globalsettings/shiftsettings")
        .then((response) => {
          if (response.data.data.length) {
            for (let i = 0; i < response.data.data.length; i++) {
              if (
                response.data.data[i].global_settings_key ===
                "start_day_of_week"
              )
                this.startDayOfWeek =
                  response.data.data[i].global_settings_value;
            }
          }
          this.setCurrentWeekDates();
          this.getAllShiftList();
          return this.fetchScheduleData(this.searchData, showLoader);
        })
        .catch((error) => {
          var response = error.response;
          console.error(response);
          this.startDayOfWeek = "Monday"; // Default value

          this.setCurrentWeekDates();
          this.getAllShiftList();
          return this.fetchScheduleData(this.searchData, showLoader);
        });
    },
  },
  created() {
    this.$store
      .dispatch("userPermissions", { module: "schedule", action: "read" })
      .then((response) => {
        this.hasReadPermission = null;
        this.$nextTick(() => {
          this.hasReadPermission = response === "true";

          if (!this.hasReadPermission) {
            notification.open({
              message: "You don't have access to this page!",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            var user_role = window.localStorage.getItem("role");

            if (user_role && user_role.includes("Employee")) {
              this.$router
                .push({ name: "employee-dashboard" })
                .catch((error) => {});
            } else {
              this.$router
                .push({ name: "admin-dashboard" })
                .catch((error) => {});
            }
          }
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "schedule", action: "create" })
      .then((response) => {
        this.hasCreatePermission = null;
        this.$nextTick(() => {
          this.hasCreatePermission = response === "true";
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "schedule", action: "write" })
      .then((response) => {
        this.hasEditPermission = null;
        this.$nextTick(() => {
          this.hasEditPermission = response === "true";
        });
      });

    this.sDate = null;
    this.eDate = null;

    const start_date = moment().format("YYYY-MM-DD");
    const end_date = moment().add(5, "days").format("YYYY-MM-DD");

    this.$nextTick(() => {
      this.sDate = start_date;
      this.eDate = end_date;
    });

    // this.fetchScheduleData();
    // this.getAllShiftList();
    this.fetchWeekDay();
  },
  computed: {
    sortedScheduleData() {
      const data = [...this.scheduleData];

      return data.sort((a, b) => {
        // Count shifts for employee 'a'
        const aShiftCount = this.dates.reduce((count, date) => {
          return count + (a[date]?.length || 0);
        }, 0);

        // Count shifts for employee 'b'
        const bShiftCount = this.dates.reduce((count, date) => {
          return count + (b[date]?.length || 0);
        }, 0);

        // Sort in descending order (most shifts first)
        return bShiftCount - aShiftCount;
      });
    },
    originalColumn() {
      return this.columns_.filter((column) => column.visibility);
    },
    isModalLocked() {
      return this.isDataLoading;
    },
  },
};
</script>

<style scoped>
.card {
  min-height: 93px;
}
th.ant-table-cell.ant-table-cell-fix-left.ant-table-cell-fix-left-last {
  z-index: 1;
}
td.ant-table-cell.ant-table-cell-fix-left.ant-table-cell-fix-left-last {
  z-index: 1;
}

:deep(.ant-table-wrapper .ant-table-tbody > tr > td) {
  padding: 4px 4px !important;
}

:deep(
    .ant-table-wrapper .ant-table-cell-fix-left,
    .ant-table-wrapper .ant-table-cell-fix-right
  ) {
  z-index: 1;
}

.drag-ghost {
  opacity: 0.4;
  width: 100% !important;
  display: block !important;
}

.drag-chosen {
  transform: rotate(1deg);
  width: 100% !important;
  display: block !important;
}
</style>
